import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/foretag";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/foretag")(withAlternates(routeOptions, "/foretag"));
